import { useAtom } from "jotai";

import { ClientCyclesAtom, useGlobalMMMStore } from "../mmm-provider";

export const useClientCycles = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [clientCycles, setClientCycles] = useAtom(ClientCyclesAtom, {
    store: GlobalMMMStore,
  });

  return [clientCycles, setClientCycles] as const;
};
